import { Link } from "react-router-dom";
import "./Offering.scss";

function Offering({
  imgSrc,
  imgAlt,
  heading,
  subheading,
  desc,
  disableLink = false,
}: {
  imgSrc: string;
  imgAlt: string;
  heading: string;
  subheading?: string;
  desc: string;
  disableLink?: boolean;
}) {
  const img = <img src={imgSrc} alt={imgAlt} className="offering__img" />;

  return (
    <div className="offering">
      {disableLink ? img : <Link to={`/menu/${heading}`}>{img}</Link>}
      <h3>
        {heading}
        <br />
        {subheading}
      </h3>
      <hr className="divider--decorative" />
      <p className="offering__desc">{desc}</p>
    </div>
  );
}

export default Offering;
